/* eslint-disable spaced-comment */
/* eslint-disable no-param-reassign */
import { combineReducers, createStore, applyMiddleware } from 'redux';
import { reducer as reduxFormReducer } from 'redux-form';
import thunk from 'redux-thunk';
// import logger from 'redux-logger';
import {
  sidebarReducer,
  themeReducer,
  authenticationReducer,
  userReducer,
  alertReducer,
  companyReducer,
  groupReducer,
  uiReducer,
  sessionReducer,
  appointmentReducer,
  languageReducer,
  teacherReducer,
} from '../../redux/reducers/index';

const middlewares = [thunk];
// const middlewares = [thunk, logger];
const appReducer = combineReducers({
  form: reduxFormReducer, // mounted under "form",
  theme: themeReducer,
  sidebar: sidebarReducer,
  authentication: authenticationReducer,
  user: userReducer,
  alert: alertReducer,
  company: companyReducer,
  group: groupReducer,
  ui: uiReducer,
  session: sessionReducer,
  appointment: appointmentReducer,
  language: languageReducer,
  teacher: teacherReducer,
});

const rootReducer = (state, action) => {
  // when a logout action is dispatched it will reset redux state
  if (action.type === 'USER_LOGGED_OUT') {
    state = undefined;
  }

  return appReducer(state, action);
};

const store = createStore(rootReducer, applyMiddleware(...middlewares));

export default store;
